import { createWithdrawReducer } from '@ppay/client'

import { createMerchantWithdrawAction } from '../../../actions'

export const createWithdraw = createWithdrawReducer(createMerchantWithdrawAction)
